import { getUnreadedMessageCount } from "@/api/message.js";
const state = {
  // 当前轮播
  homeCarousel: 'Search',
  unReadedMessageCount:0

};

const mutations = {
  // 设置当前轮播
  setHomeCarousel: (state, payload) => {
    state.homeCarousel = payload;
  },
  SetUnreadedMessageCount:(state,unReadedMessageCount) => {
    state.unReadedMessageCount = unReadedMessageCount
  }
};

const actions = {
  // 获取用户信息
  async updateUnreadedMessageCount({ commit }) {
    let params = {readed:0}
    let interval = null;
    let unreadedMessageCount=()=> {
      getUnreadedMessageCount(params).then(res=> {
        if(res.code === 0) {
          commit('SetUnreadedMessageCount', res.data);
        }
      })
    }
    unreadedMessageCount()
    // interval = setInterval(unreadedMessageCount, 1000*10);
  },
};

export default {
  state,
  mutations,
  actions
};
